<template>
    <b-modal
        v-model="modalShow"
        size="lg"
        class="reservationModal"
        title="お支払い方法を選択"
        hide-header
        hide-footer
        @cancel="close"
        @hidden="close">
        <div v-if="isLoadedState">
            <div
                v-if="helper.isDefaultPlan(user.plan) && !helper.isCompanyLegacy(user)"
                class="card mb-3">
                <div class="card-header">クーポンの使用</div>
                <div class="card-body">
                    <div class="vc-user-coupon d-flex align-items-center">
                        <label
                            for="user_coupon_not_use"
                            class="vc-user-coupon__label">
                        </label>
                        <input
                            v-model="selectedUserCoupon"
                            id="user_coupon_not_use"
                            name="user_coupon"
                            type="radio"
                            class="vc-user-coupon__input"
                            :value="null"/>
                        <div class="vc-user-coupon__name">使用しない</div>
                    </div>

                    <template v-if="filteredUserCoupons.length > 0">
                        <div
                            v-for="userCoupon in filteredUserCoupons"
                            :key="`user_coupon_${userCoupon.id}`">
                            <div
                                class="vc-user-coupon d-flex align-items-center"
                                :class="{ 'vc-user-coupon--disabled' : isDisabledCoupon(userCoupon) }">
                                <label
                                    :for="`user_coupon_${userCoupon.id}`"
                                    class="vc-user-coupon__label">
                                </label>
                                <input
                                    v-model="selectedUserCoupon"
                                    :id="`user_coupon_${userCoupon.id}`"
                                    name="user_coupon"
                                    type="radio"
                                    class="vc-user-coupon__input"
                                    :value="userCoupon"/>
                                <div>
                                    <div class="vc-user-coupon__name small text-muted">{{ userCoupon.name }}</div>
                                    <div class="vc-user-coupon__discount">
                                        <span>{{ userCoupon.discount.toLocaleString() }}</span><!--
                                            --><span>円引き</span>
                                    </div>
                                    <div class="vc-user-coupon__expired_at">
                                        <span><b-icon-clock/>&nbsp;{{ expiredDate(userCoupon) }}</span>
                                        <span>{{ expiredTime(userCoupon) }}</span>
                                        <span>まで（{{ user.timezone }}）</span>
                                    </div>
                                    <div class="vc-user-coupon__restrict">
                                        <div v-if="userCoupon.has_doctor_menu">
                                            <div class="d-inline-block">メニュー限定&nbsp;</div>
                                            <template v-if="userCoupon.doctor_menus.length > 2">
                                                <div
                                                    v-for="n in 2"
                                                    class="d-inline-block">
                                                    <span>{{ `${userCoupon.doctor_menus[n-1].title}（${userCoupon.doctor_menus[n-1].doctor ? userCoupon.doctor_menus[n-1].doctor.full_name : '退会済の医師'}）` }}</span><!--
                                                 --><span v-if="n < 2">、</span><!--
                                                 --><span v-if="n === 2">…ほか</span>
                                                </div>
                                            </template>
                                            <template v-else>
                                                <div
                                                    v-for="(doctor_menu, index) in userCoupon.doctor_menus"
                                                    class="d-inline-block">
                                                    <span>{{ `${doctor_menu.title}（${doctor_menu.doctor ? doctor_menu.doctor.full_name : '退会済の医師'}）` }}</span><!--
                                                 --><span v-if="userCoupon.doctor_menus.length > index + 1">、</span>
                                                </div>
                                            </template>
                                        </div>
                                        <div v-else-if="userCoupon.has_doctor">
                                            <div
                                                v-for="(doctor, index) in userCoupon.doctors"
                                                class="d-inline-block">
                                                <span>{{ doctor.full_name }}</span><!--
                                            --><span v-if="userCoupon.doctors.length > index + 1">、</span><!--
                                            --><span v-else>&nbsp;医師限定</span>
                                            </div>
                                            <div v-if="userCoupon.doctors.length < 1">退会済の医師限定</div>
                                        </div>
                                        <div v-if="userCoupon.min_consultation_price">
                                            <span>{{ userCoupon.min_consultation_price.toLocaleString() }}円以上の{{ $locale.consultation_host }}限定</span>
                                        </div>
                                        <div v-if="userCoupon.is_only_matching">
                                            <span>マッチング予約限定</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div
                            v-if="errors.user_coupon_id"
                            class="invalid-feedback d-block mt-1">
                            {{ errors.user_coupon_id[0] }}
                        </div>
                    </template>

                    <section class="couponCodeRetrieve">
                        <h3 class="couponCodeRetrieveHeading">
                            <b-icon-question-circle-fill/><!--
                         --><span>クーポンが見当たらない場合</span>
                        </h3>
                        <p>
                            <span>クーポンコードの入力がまだお済みでない方は、</span><!--
                         --><a href="#" @click="openModalUserCouponCode">こちら</a>からクーポンを発行してください。
                        </p>
                    </section>
                </div>
            </div>

            <div
                v-show="!canSkipPayment"
                class="card mb-3">
                <div class="card-header">お支払い方法の選択</div>
                <div class="card-body">
                    <div class="input-group">
                        <select
                            v-model="selectedPaymentMethod"
                            id="payment_method_id"
                            class="form-control">
                            <option
                                v-for="paymentMethod in filteredPaymentMethods"
                                :key="`payment_method_${paymentMethod.id}`"
                                :value="paymentMethod">
                                {{ paymentMethod.name }}
                            </option>
                        </select>
                        <div
                            v-if="errors.payment_method_id"
                            class="invalid-feedback d-block mt-1">
                            {{ errors.payment_method_id[0] }}
                        </div>
                    </div>

                    <div
                        v-show="isCredit"
                        class="mt-3">
                        <store-credit-card-form
                            :data-pubkey="dataPubkey"
                            :schedule="schedule">
                        </store-credit-card-form>
                    </div>
                </div>
            </div>

            <b-button
                class="nextButton"
                :disabled="(isCredit && !hasCreditCard && !canSkipPayment) || inProgress"
                @click="handleOk">
                次へ進む
            </b-button>
        </div>
    </b-modal>
</template>

<script>
    import YokumiruHelper from '../../../YokumiruHelper'
    import constants from '../../../constants'
    import { mapMutations } from 'vuex'

    export default {
        props: {
            paymentMethods: {
                type: Array,
                required: true,
            },
            dataPubkey: {
                type: String,
                default: null,
            },
        },

        data: function () {
            return {
                helper: YokumiruHelper,
                paymentMethodCash: constants.payment_methods.cash,
                modalShow: false,
                inProgress: false,
                mode: null,
                user: null,
                doctor: null,
                doctorMenu: null,
                schedule: null,
                medicalCourse: null,
                prevConsultation: null,
                selectedPaymentMethod: null,
                selectedUserCoupon: null,
                errors: {},
                failed: false,
                timer: null,
                isInitStoreCreditCardForm: false,
                hasCreditCard: false,
                canSkipPayment: false,
            }
        },

        computed: {
            isLoadedState: function () {
                if (this.mode === 'default' || this.mode === 'auto') {
                    return this.user !== null
                        && this.medicalCourse !== null
                        && this.doctor !== null
                        && this.doctorMenu !== null
                        && this.schedule !== null
                        // && this.isAutoReserved !== null
                }
                else if (this.mode === 'matching') {
                    return this.user !== null
                        && this.medicalCourse !== null
                        && this.schedule !== null
                        // && this.isAutoReserved !== null
                }
            },

            /**
             * 相談料の支払いが必要かどうか
             * @return {boolean}
             */
            isPayPrice: function () {
                if (this.$locale.type !== 'consul') return false
                if (this.doctorMenu && this.doctorMenu.is_health_package) return false

                return this.user && this.user.plan.is_pay_consultation_price
            },

            /**
             * お支払い方法リストのフィルタリング
             *
             * @return {array}
             */
            filteredPaymentMethods: function () {
                if (this.$store.state.configs.subscription == 1) {
                    return this.paymentMethods.filter((pm) => pm.id === constants.payment_methods.credit)
                }
                else {
                    return this.paymentMethods
                }
            },

            /**
             * 所持クーポンのフィルタリング
             * （相談予約カテゴリのクーポンだけにする）
             *
             * @return {array}
             */
            filteredUserCoupons: function () {
                return this.helper.filteredUserCoupons(this.user)
            },

            /**
             * 最大割引となる所持クーポンを返す
             *
             * @return {object|null}
             */
            maxDiscountCoupon: function () {
                if (this.isSkip) return null

                let result = null
                const consultationPrice = this.doctorMenu ? this.doctorMenu.consultation_price : this.medicalCourse.matching_price

                this.filteredUserCoupons.forEach((userCoupon) => {
                    if (userCoupon.is_only_matching && this.mode !== 'matching') {
                        return
                    }
                    if (userCoupon.min_consultation_price) {
                        if (consultationPrice < userCoupon.min_consultation_price) return
                    }
                    if (userCoupon.has_doctor_menu) {
                        if (!this.doctorMenu) return
                        if (userCoupon.doctor_menus.every((dm) => dm.id !== this.doctorMenu.id)) return
                    }
                    if (userCoupon.has_doctor) {
                        if (!this.doctorMenu) return
                        if (userCoupon.doctors.every((doctor) => doctor.id !== this.doctorMenu.doctor_id)) return
                    }

                    if (result === null || userCoupon.discount > result.discount) {
                        result = userCoupon
                    }
                })
                return result
            },

            /**
             * 決済方法にクレジットカードが選択されているかどうか
             *
             * @return {boolean}
             */
            isCredit: function () {
                if (!this.selectedPaymentMethod) {
                    return false
                }
                return this.selectedPaymentMethod.id === constants.payment_methods.credit
            },

            /**
             * 決済方法選択のスキップ判定
             * （スキップする場合は問診入力モーダルへ進む）
             */
            isSkip: function () {
                if (Number(this.$store.state.configs.payment) !== 1) return true
                if (this.$locale.type !== 'consul') return false
                if (!this.user) return false

                // 無料 or 相談料の支払いが不要なケース or 法人会員（旧タイプ）
                return this.actualConsultationPrice <= 0
                    || !this.isPayPrice
                    || this.helper.isCompanyLegacy(this.user)
            },

            /**
             * 支払い方法選択をスキップする場合の使用クーポンデフォルト値
             *
             * @return {object|null}
             */
            confirmUserCoupon: function () {
                return null
            },

            /**
             * 再相談可能かどうか
             *
             * @see \App\Models\DoctorMenu::isRepeatable() ※同じロジックで判定しています
             */
            isRepeatable: function () {
                if (!this.user || !this.doctorMenu) {
                    return false
                }

                return this.helper.isRepeatable(
                    this.doctorMenu,
                    this.$store.state.userConsultations.recentlyConsultations,
                    this.user.timezone
                )
            },

            /**
             * 再相談可能かどうかに応じて実際の相談料を返す
             *
             * @returns {number}
             */
            actualConsultationPrice: function () {
                if (this.isRepeatable && this.doctorMenu.repeat_consultation_price !== null) {
                    return this.doctorMenu.repeat_consultation_price
                }
                return this.doctorMenu ? this.doctorMenu.consultation_price : this.medicalCourse.matching_price
            },
        },

        created: function() {
            bus.$on('open-modal-reservation-payment-method', this.open)
            bus.$on('close-modal-reservation-payment-method', this.close)
            bus.$on('user-reservation-completed', this.initSelectedPaymentMethod)
            bus.$on('init-store-credit-card-form-completed', () => { this.isInitStoreCreditCardForm = true })
            bus.$on('has-credit-card', () => { this.hasCreditCard = true })
            bus.$on('user-coupon-published', this.fetchMe)
            this.initSelectedPaymentMethod()
        },

        beforeDestroy: function() {
            bus.$off('open-modal-reservation-payment-method')
            bus.$off('close-modal-reservation-payment-method')
            bus.$off('user-reservation-completed')
            bus.$off('init-store-credit-card-form-completed')
        },

        methods: {
            ...mapMutations({
                setPaymentMethod: 'reservation/setPaymentMethod',
                setUserCoupon: 'reservation/setUserCoupon',
                setUser: 'reservation/setUser',
            }),

            /**
             * ログインユーザ取得
             */
            fetchMe: function () {
                return axios.get(constants.user.me.endpoint.base)
                    .then(({data}) => {
                        this.user = data.data
                        this.setUser(this.user)
                    })
            },

            /**
             * クーポン適用後の相談料計算
             *
             * @param {number} price
             * @param {object} coupon
             * @return {number}
             */
            calcDiscount: function (price, coupon) {
                if (coupon.discount_unit === 'percent') {
                    return price * coupon.discount / 100
                }
                else if (coupon.discount_unit === 'static') {
                    return coupon.discount
                }
                else if (coupon.discount_unit === 'daily') {
                    return coupon.discount
                }
                return 0
            },

            /**
             * 使用できないクーポンの判定
             *
             * @param {object} userCoupon
             * @return {boolean}
             */
            isDisabledCoupon(userCoupon) {
                if (userCoupon.is_only_matching && this.mode !== 'matching') return true
                if (userCoupon.has_doctor_menu && !this.doctorMenu) return true
                if (userCoupon.has_doctor && !this.doctor) return true

                if (userCoupon.min_consultation_price) {
                    const price = this.doctorMenu ? this.doctorMenu.consultation_price : this.medicalCourse.matching_price
                    if (price < userCoupon.min_consultation_price) {
                        return true
                    }
                }
                if (userCoupon.has_doctor_menu) {
                    if (userCoupon.doctor_menus.every((doctorMenu) => doctorMenu.id !== this.doctorMenu.id)) {
                        return true
                    }
                }
                if (userCoupon.has_doctor) {
                    if (userCoupon.doctors.every((doctor) => doctor.id !== this.doctor.id)) {
                        return true
                    }
                }
                return false
            },

            /**
             * お支払い方法の選択初期値
             */
            initSelectedPaymentMethod: function () {
                if (this.$store.state.configs.subscription == 1) {
                    this.selectedPaymentMethod = this.paymentMethods.find((pm) => pm.id === constants.payment_methods.credit)
                }
                else {
                    this.selectedPaymentMethod = this.paymentMethods[0]
                }
            },

            /**
             * モーダル表示
             */
            open: async function () {
                this.mode = this.$store.state.reservation.mode
                this.user = this.$store.state.reservation.user
                this.doctorMenu = this.$store.state.reservation.doctorMenu
                this.doctor = this.doctorMenu ? this.doctorMenu.doctor : null
                this.medicalCourse = this.$store.state.reservation.medicalCourse
                this.schedule = this.$store.state.reservation.schedule
                this.prevConsultation = this.$store.state.reservation.prevConsultation

                this.errors = {}

                if (this.isSkip) {
                    this.setPaymentMethod(this.helper.confirmPaymentMethod(this.user))
                    this.setUserCoupon(this.confirmUserCoupon)
                    bus.$emit('open-modal-reservation-interview')
                }
                else {
                    this.modalShow = true
                    this.selectedUserCoupon = this.maxDiscountCoupon
                    this.initStoreCreditCardForm()
                }
            },

            /**
             * モーダル非表示
             */
            close: function() {
                this.modalShow = false
                this.selectedUserCoupon = null
                this.isInitStoreCreditCardForm = false
                this.hasCreditCard = false
                this.canSkipPayment = false
            },

            /**
             * 次へボタン押下時
             *
             * @param {object} e
             */
            handleOk: async function(e) {
                e.preventDefault()

                if (this.inProgress) return
                this.inProgress = true

                const params = {
                    medical_course_id: this.medicalCourse.id,
                    doctor_id: this.doctor ? this.doctor.id : null,
                    doctor_menu_id: this.doctorMenu ? this.doctorMenu.id : null,
                    start_time: this.startDateTime().format('YYYY-MM-DD HH:mm:ss'),
                    end_time: this.endDateTime().format('YYYY-MM-DD HH:mm:ss'),
                    payment_method_id: this.selectedPaymentMethod.id,
                    user_coupon_id: this.selectedUserCoupon ? this.selectedUserCoupon.id : null,
                    confirm: 1,
                }

                await axios.post(constants.user.consultations.endpoint.base, params)
                    .then(({data}) => {
                        this.errors = {}
                        if (data.status === 'OK') {
                            this.pushAnalyticsDataLayer()
                            this.setPaymentMethod(this.selectedPaymentMethod)
                            this.setUserCoupon(this.selectedUserCoupon)
                            bus.$emit('open-modal-reservation-interview')
                        }
                    })
                    .catch(({response}) => {
                        if (response &&
                            response.hasOwnProperty('data') &&
                            response.data.hasOwnProperty('errors')) {
                            this.errors = response.data.errors
                            bus.$emit('alert-danger')
                        }
                        else {
                            bus.$emit('alert-danger', 'システムエラーが発生しました。')
                        }
                    })

                this.inProgress = false
            },

            /**
             * GoogleAnalytics GA4 カスタムイベント発火
             */
            pushAnalyticsDataLayer: function () {
                if (this.$locale.type !== 'consul') return

                const doctorMenuId = this.doctorMenu ? this.doctorMenu.id : null
                const doctorMenuTitle = this.doctorMenu ? this.doctorMenu.title : null

                window.dataLayer = window.dataLayer || []
                window.dataLayer.push({
                    event: 'dl__selectPaymentMethod',
                    paymentMethodId: this.selectedPaymentMethod.id,
                    paymentMethodName: this.selectedPaymentMethod.name,
                    doctorMenuId: doctorMenuId,
                    // doctorMenuTitle: this.isAutoReserved ? 'おすすめ相談' : this.doctorMenu.title,
                    doctorMenuTitle: doctorMenuTitle,
                })
            },

            /**
             * 相談開始日時フォーマット
             *
             * @return {moment}
             */
            startDateTime: function () {
                if (this.schedule.start_time === '24:00') {
                    this.schedule.start_time = '00:00'
                }

                const format = this.schedule.date.format('YYYY-MM-DD')

                return this.helper.jstTime(`${format} ${this.schedule.start_time}:00`, this.user.timezone)
            },

            /**
             * 相談終了日時フォーマット
             *
             * @return {moment}
             */
            endDateTime: function () {
                if (this.mode === 'default') {
                    return this.startDateTime().add(this.doctorMenu.consultation_minutes, 'minutes')
                }
                return this.startDateTime().add(this.medicalCourse.matching_minutes, 'minutes')
            },

            /**
             *「戻る」ボタン押下時
             *
             * @param {object} e
             */
            back: function(e) {
                e.preventDefault()
                this.close()
            },

            /**
             * クーポン使用期限の無期限判定
             *
             * @param {object} user_coupon
             * @return {boolean}
             */
            isExpiredNothing: function (user_coupon) {
                return user_coupon.expired_at === '2100-01-01 00:00:00'
            },

            /**
             * クーポン使用期限表記（日付）
             *
             * @param {object} user_coupon
             * @return {string}
             */
            expiredDate: function (user_coupon) {
                return this.helper.dateForHuman(user_coupon.expired_at, this.user.timezone)
            },

            /**
             * クーポン使用期限表記（時刻）
             *
             * @param {object} user_coupon
             * @return {string}
             */
            expiredTime: function (user_coupon) {
                return this.helper.timeForHuman(user_coupon.expired_at, this.user.timezone)
            },

            /**
             * クーポン使用期限表記（曜日）
             *
             * @param {object} user_coupon
             * @return {string}
             */
            expiredDay: function (user_coupon) {
                return this.helper.dayForHuman(user_coupon.expired_at, this.user.timezone)
            },

            /**
             * クーポン使用期限表記（曜日）のCSS
             *
             * @param {object} user_coupon
             * @return {string}
             */
            expiredDayCSS: function (user_coupon) {
                let userTime, day
                userTime = this.helper.userTime(user_coupon.expired_at, this.user.timezone)
                day = userTime.day()

                if (day === 0) return 'text-danger small font-weight-bold'
                if (day === 6) return 'text-yokumiru-blue small font-weight-bold'

                return ''
            },

            /**
             * 決済方法にクレジットカードが選択されている場合
             * クレジットカード登録フォームをセットアップする
             */
            initStoreCreditCardForm: function () {
                // セットアップ済みなら何もしない
                if (this.isInitStoreCreditCardForm) {
                    return
                }

                if (this.isCredit) {
                    if (this.timer !== null) {
                        clearTimeout(this.timer)
                    }
                    this.timer = setInterval(() => {
                        if (document.getElementById('store-credit-card-form')) {
                            clearInterval(this.timer)
                            bus.$emit('init-store-credit-card-form')
                        }
                    }, 100)
                }
            },

            /**
             * クーポンコード入力モーダル表示
             */
            openModalUserCouponCode: function () {
                bus.$emit('open-modal-user-coupon-code')
            },
        },

        watch: {
            /**
             * 決済方法の選択が変更されたとき
             *
             * @param {object} pm
             */
            selectedPaymentMethod: function (pm) {
                if (!this.modalShow) return

                if (pm.id === constants.payment_methods.credit) {
                    this.initStoreCreditCardForm()
                }
            },

            /**
             * 使用するクーポンの選択が変更されたとき
             *
             * @param {object} coupon
             */
            selectedUserCoupon: function (coupon) {
                if (this.$locale.type !== 'consul' || coupon === null) {
                    this.canSkipPayment = false
                }
                else {
                    // クーポンを適用すると無料になる場合はクレカ登録不要にする
                    // @see https://github.com/sewii/Yokumiru/issues/592
                    const discount = this.calcDiscount(this.actualConsultationPrice, coupon)
                    this.canSkipPayment = (this.actualConsultationPrice - discount) <= 0
                }
            },
        },
    }
</script>

<style lang="scss" scoped>
.couponCodeRetrieve {
    margin-left: 12px;

    .couponCodeRetrieveHeading {
        margin: 16px 0 2px;
        font-size: 14px;
        font-weight: bold;
        color: #424a4d;

        svg {
            fill: #424a4d;
        }

        span {
            margin-left: 3px;
        }
    }

    p {
        margin-bottom: 0;
        font-size: 13px;
    }

    a {
        text-decoration: underline;

        &:hover {
            text-decoration: none;
        }
    }
}

.vc-user-coupon {
    position: relative;
    padding: 14px 15px;
    margin-bottom: 12px;
    background: #fcfcfc;
    border: 1px solid #dee2e6;
    border-radius: 5px;

    &.vc-user-coupon--disabled {
        &::after {
            content: '選択できません　　　';
            position: absolute;
            left: 0;
            top: 0;
            display: flex;
            justify-content: flex-end;
            align-items: center;
            z-index: 2;
            width: 100%;
            height: 100%;
            color: #fff;
            font-size: 13px;
            font-weight: bold;
            text-align: center;
            background: rgba(0, 0, 0, 0.3);
            border-radius: 5px;
        }
    }

    .vc-user-coupon__input {
        margin-right: 12px;
    }

    .vc-user-coupon__label {
        position: absolute;
        left: 0;
        top: 0;
        z-index: 2;
        display: block;
        width: 100%;
        height: 100%;
        cursor: pointer;
    }

    .vc-user-coupon__name {
        font-size: .75rem;
        line-height: 1.3;
    }

    .vc-user-coupon__discount {
        margin-left: 1px;
        color: #5f6366;
        font-size: 1.1rem;
        font-weight: bold;
        line-height: 1.3;

        span {
            &:nth-child(2) {
                font-size: .75rem;
            }
        }
    }

    .vc-user-coupon__expired_at {
        margin-top: 5px;
        color: #5f6366;
        font-size: .7rem;

        span {
            &:nth-child(1),
            &:nth-child(2) {
                font-weight: bold;
            }
        }
    }

    .vc-user-coupon__restrict {
        margin-left: 15px;
        color: #5f6366;
        font-size: .7rem;
    }
}

.nextButton {
    display: block;
    width: 210px;
    height: 42px;
    line-height: 42px;
    padding: 0;
    margin: 0 auto;
    color: #fff;
    font-weight: bold;
    text-align: center;
    background-color: #CF798A;
    border: none;
    border-radius: 8px;
    cursor: pointer;

    &:disabled {
        cursor: default;
    }
}
</style>
